import { createContext, useContext } from 'react';
import { userInfoSync } from 'hub-http/userInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const GatesContext = /*#__PURE__*/createContext(null);

/**
 * Provides a context for gating information when user authentication is not available.
 * This should not typically be used, except in cases where the application is not authenticated,
 * such as in a strange iframe hierarchy.
 *
 * @param gates - An array of gate names.
 * @description This component is used to provide gating information when user authentication is not available. This should not typically be used, except in cases where the application is not authenticated, such as in a strange iframe hierarchy.
 * @example
 * ```tsx
 * <NoAuthGatesProvider gates={['my-gate']}>
 *  <MyComponent />
 * </NoAuthGatesProvider>
 * ```
 */
export const NoAuthGatesProvider = ({
  gates,
  children
}) => /*#__PURE__*/_jsx(GatesContext.Provider, {
  value: gates,
  children: children
});
const checkGates = (gateName, gates) => gates.includes(gateName);
export const getGates = () => {
  try {
    const auth = userInfoSync();
    return auth.gates;
  } catch (err) {
    return [];
  }
};
export const useIsUngated = gateName => {
  const contextGates = useContext(GatesContext);
  const gates = contextGates || getGates();
  return checkGates(gateName, gates);
};